import(/* webpackMode: "eager" */ "/usr/local/src/rallly/apps/web/src/app/global-error.tsx");
